<template>
  <el-dialog class="message-notice-dialog" :visible="visible" :title="$t('messageNotice.messageNotcieDialogTitle')" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div class="notice-desc">
      {{ $t('messageNotice.messageNotcieDialogDesc1') }}
      <a href="javascript:;" @click="handleDetail">{{ $t('messageNotice.messageNotcieDialogDetail') }}</a>
      {{ $t('messageNotice.messageNotcieDialogDesc2') }}
    </div>
    <div v-if="messageNoticeData.emailSensitization" class="notice-item">
      <el-checkbox v-model="emailNotice">
        {{ $t('login.email') }}：{{ messageNoticeData.emailSensitization }}
      </el-checkbox>
    </div>
    <div v-if="messageNoticeData.phoneNumberSensitization" class="notice-item">
      <el-checkbox v-model="smsNotice">
        {{ $t('messageNotice.message') }}：{{ messageNoticeData.phoneNumberSensitization }}
      </el-checkbox>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm(false)">{{ $t('messageNotice.considerLater') }}</el-button>
      <el-button type="primary" class="new-register" @click="handleConfirm(true)">{{ $t('standard.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { setPushConfigTmpToken } from '../../../api/common/site'
export default {
  name: 'MessageNoticeDialog',
  data() {
    return {
      title: '',
      content: ''
    }
  },
  computed: {
    ...mapGetters(['messageNoticeData']),
    visible: {
      get() {
        return this.messageNoticeData.show
      },
      set(visible) {
        this.setMessageNoticeData({
          ...this.messageNoticeData,
          show: visible,
        })
      }
    },
    smsNotice: {
      get() {
        return this.messageNoticeData.promotionSmsFlag
      },
      set(promotionSmsFlag) {
        this.setMessageNoticeData({
          ...this.messageNoticeData,
          promotionSmsFlag
        })
      }
    },
    emailNotice: {
      get() {
        return this.messageNoticeData.promotionEmailFlag
      },
      set(promotionEmailFlag) {
        // 设置消息通知数据
        this.setMessageNoticeData({
          // 展开当前的消息通知数据对象
          ...this.messageNoticeData,
          // 设置促销邮件标志位
          promotionEmailFlag
        })
      }
    }
  },
  methods: {
    ...mapMutations({
      setMessageNoticeData: 'site/SET_MESSAGE_NOTICE_DATA_INDATA',
      setCookieTerms: 'app/SET_COOKIE_TERMS',
    }),
    handleDetail() {
      this.setCookieTerms({
        title: this.$t('messageNotice.messageNoticeDetailTitle'),
        show: true,
        type: 101
      })
    },
    async handleConfirm(type) {
      const params = {
        promotionEmailFlag: this.emailNotice,
        promotionSmsFlag: this.smsNotice,
        tmpToken: this.messageNoticeData.tmpToken
      }

      if (type === false) {
        params.promotionSmsFlag = false
        params.promotionEmailFlag = false
      }
      if (!this.messageNoticeData.phoneNumberSensitization) {
        delete params.promotionSmsFlag
      }
      if (!this.messageNoticeData.emailSensitization) {
        delete params.promotionEmailFlag
      }
      try {
        await setPushConfigTmpToken(params)
        this.setMessageNoticeData({
          ...this.messageNoticeData,
          show: false,
        })
        this.messageNoticeData.cb && this.messageNoticeData.cb()
      } catch (error) {
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.notice-desc {
  margin: 20px 0;
  color: #666;
  ::v-deep a {
    color: #409EFF;
    text-decoration: none;
    cursor: pointer;
  }
}

.notice-item {
  margin: 15px 0;
}

::v-deep .el-autocomplete {
  width: 100%;
}

.account-content {
  padding-left: 24px;
}

.message-notice-dialog{
  ::v-deep .el-dialog__body {
    text-align: left;
    padding: 0 20px;
  }
}
</style>
